import { ElectionMainMenu } from '~/definitions/election';
import { getStore } from '~/mobx/AppStore';

function getElectionMenu() {
    const electionMenuStore = getStore().electionMenuStore;
    const companyStore = getStore().companyStore;
    const selectedCompany = companyStore.selectedCompany;

    if (selectedCompany) {
        const regionList = electionMenuStore.regions;
        const formattedRegionList = regionList.map((region: any) => ({
            id: region.id,
            href: '#',
            text: region.name,
            active: region.active ?? false,
        }));

        const electionMenu: ElectionMainMenu = {
            active: true,
            href: '#',
            id: selectedCompany.id || '',
            regionList: formattedRegionList,
            text: selectedCompany.name || '',
        };

        return electionMenu;
    }

    return null;
}

export default getElectionMenu;
